/* global axios */

// Billing do sistema de vendas. Rotas fora do escopo accounts/:id normal de
// proposito: funcionam com conta suspensa (paywall).
const accountIdFromRoute = () => {
  const [, accountId] = window.location.pathname.match(/accounts\/(\d+)/) || [];
  return accountId;
};

export default {
  getBilling() {
    return axios.get(`/api/v1/vincto/accounts/${accountIdFromRoute()}/billing`);
  },
  subscribe(planName, cpfCnpj) {
    return axios.post(
      `/api/v1/vincto/accounts/${accountIdFromRoute()}/billing/subscribe`,
      { plan_name: planName, cpf_cnpj: cpfCnpj }
    );
  },
};
